module.exports = __webpack_public_path__ + "static/stock-image-2-d9ba86dbc6db374f43eb8e61b4c04e4c.jpg";